// src/pages/Dashboard/DashboardController.ts
import {useState, useEffect} from 'react'
import {getDashboardStats} from '../../services/Stats'
import {getWallets} from '../../services/Wallets'
import {DashboardStats} from '../../types'

export const useDashboardController = () => {
    const [stats, setStats] = useState<DashboardStats | null>(null)
    const [wallets, setWallets] = useState({alfa: 0, touch: 0})
    const [loading, setLoading] = useState(true)
    const [sidebarOpen, setSidebarOpen] = useState(false)

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const [statsData, walletsData] = await Promise.all([
                getDashboardStats(),
                getWallets()
            ])
            console.log('✅ Stats Data:', statsData)
            console.log('✅ Wallets Data:', walletsData)
            setStats(statsData)
            setWallets(walletsData)
        } catch (error) {
            console.error('❌ Error:', error)
        } finally {
            setLoading(false)
        }
    }

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen)

    return {stats, wallets, loading, sidebarOpen, toggleSidebar}
}